import { isEmpty, isNil } from 'lodash';
import React from 'react';
import { generateCmsUrl } from '../../services/cms/cmsService';

const BlogHeader = ({ banner, description, title }) => {
    return (
        <div className='blog-header'>
            {!isNil(banner) && !isEmpty(banner) ? (
                <img
                    alt={banner.alternativeText}
                    src={generateCmsUrl(banner.url)}
                    style={{ alignSelf: 'stretch' }}
                />
            ) : (
                <></>
            )}
            {!isNil(title) && (
                <div className='blog-header-title'>
                    <h1>{title}</h1>
                </div>
            )}
            {!isNil(description) && !isEmpty(description) ? (
                <div
                    className='blog-header-description'
                    dangerouslySetInnerHTML={{
                        __html: description.htmlText,
                    }}
                />
            ) : (
                <></>
            )}
        </div>
    );
};

export default BlogHeader;
